<template>
  <div class="w-100 mb-5">
    <div class="d-flex flex-column align-items-center">
      <error-banner v-if="error" :message="error" class="col-12"></error-banner>
      <h3 class="row mb-3 px-3">Do you want to hear about our updates and offers?</h3>
      <div class="row">
        <button class="btn mr-2" v-bind:class="{ 'btn-tertiary': marketing }" @click="setMarketingSetting(true)" :disabled="acceptMarketingUpdated">
          Yes
        </button>
        <button class="btn ml-2" v-bind:class="{ 'btn-tertiary': !marketing }" @click="setMarketingSetting(false)" :disabled="acceptMarketingUpdated">
          No
        </button>
      </div>
    </div>
    <validation-message v-if="marketingSettingValidation" :message="marketingSettingValidation" class="pt-2"></validation-message>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { MarketingSettingUpdateMixin } from '@/mixins/Registration/MarketingSettingUpdateMixin'
import { ClientOnboardingInviteCacheMixin } from '@/mixins/Registration/ClientOnboardingInviteCacheMixin'
import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue'
import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue'

export default {
  name: 'ClientAcceptMarketingSection',
  mixins: [MarketingSettingUpdateMixin, ClientOnboardingInviteCacheMixin],
  computed: {
    ...mapState('ApplicationEvents', [
      'saveRegistrationEvent'
    ])
  },
  watch: {
    saveRegistrationEvent () {
      this.handleUpdateEvent()
    },
    alternateContactUpdated () {
      this.handleUpdateEvent()
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setAcceptMarketingUpdated'
    ]),
    afterUpdateMarketingSetting () {
      this.setAcceptMarketingUpdated()
    },
    handleUpdateEvent () {
      if (!this.acceptMarketingUpdated && this.alternateContactUpdated) {
        this.tryUpdateMarketingSetting()
      }
    },
    setMarketingSetting (value) {
      this.marketing = !!value
    }
  },
  components: {
    'validation-message': ValidationMessage,
    'error-banner': ErrorBanner
  }
}
</script>
